import { Component, Input } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [NgStyle],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  @Input() label = '';
  @Input() disabled = false;
  @Input() loading = false;
  @Input() icon = '';
  @Input() title = '';
  @Input() style: any;
  @Input() type:
    | 'primary-button'
    | 'primary-button-red'
    | 'primary-icon-button'
    | 'secondary-button'
    | 'secondary-icon-button'
    | 'tertiary-button'
    | 'tertiary-icon-button' = 'primary-button';
}
